import JobTitlesIndex from '@/views/jobTitles/JobTitlesIndex.vue';

export default [
  {
    path: '/job-titles',
    name: 'job-titles.index',
    component: JobTitlesIndex,
    meta: {
      title: 'jobTitles.title',
      requiresAuth: true,
      requiredPerm: 'job_titles.display',
    },
  },
];
